module.exports = __webpack_public_path__ + "assets/img/wechat_pay.0c96daad.svg";